export const ROUND_ROBIN_STAGE = 1
export const BRACKETS_STAGE = 2
